<div class="general-doc">
    <div>
        <h1><b>About Us</b></h1>
    </div>
    <div>
        <p>
            Research Arsenal is a digital primary resource archive focused on the Civil War. We
            currently have over 100,000 documents and photos with more being added to the
            collection daily. The goal of the Research Arsenal is to provide both casual and
            professional researchers with access to original documents and to preserve history by
            digitizing previously unavailable records.
        </p>
        <p>
            With our keyword and metadata tagging system, you can search for documents and
            images related to specific battles, locations, units, or even weapons and gear. With
            thousands of personal letters, Research Arsenal offers a more personal view of the war
            and the everyday lives of mid-19th century Americans
        </p>
        <p>
            Research Arsenal is a great resource for:
        </p>
        <ul>
            <li>Historians</li>
            <li>Genealogists</li>
            <li>Reenactors</li>
            <li>Educators</li>
        </ul>
        <p>
            Research Arsenal is a non-profit organization and your membership fees support keeping
            the database online as well as the digitization of future records.
        </p>
    </div>
    <br>
    <div>
        <h1><b>Digital Repository</b></h1>
    </div>
    <div>
        <p>
            Our digital collection includes over 100,000 documents and images for you to search and
            browse through. These documents include:
        </p>
        <h3>Photographs and Images</h3>
        <p>
            Scans of period photographs of battlefields, camps, daily life,
            and more as well as studio portraits. Each photograph is tagged with the individuals
            present as well as all military gear and uniforms appearing in the photo.
        </p>
        <h3>Letters (and Diaries)</h3>
        <p>
            Read thousands of fully transcribed letters and diaries written by
            soldiers and civilians on both sides of the Civil War. 
        </p>
        <h3>Quartermaster and Ordnance Specifications</h3>
        <p>
            Browse the official specifications for
            hundreds of items and weapons based on the 1862 US Ordnance Manual and the 1865
            US Quartermaster's Manual. 
        </p>
        <h3>US Ordnance Returns</h3>
        <p>
            Search or browse the US Ordnance Returns covering the period
            of the Civil War
        </p>
    </div>
</div>